import { useMemo } from 'react'
import { Tier, TierHierarchy } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'
import { PlansTier, TierCollection } from '../types/planProducts'

const pruneTier = (tiers: Tier[], hierarchy: TierHierarchy) => {
  const tier = tiers?.find((x) => x.hierarchy === hierarchy)

  return {
    ...tier,
    internalName:
      tier?.basicPlanIdentifier?.toLowerCase() ||
      tier?.premiumPlusPlanIdentifier?.toLowerCase() ||
      tier?.entitlement?.name?.toLowerCase(),
    productId: tier?.product?.id,
    displayMonthlyPrice: tier?.product?.monetizedYearPricePerMonth,
    displayMonthlyPriceWithDiscount:
      tier?.product?.monetizedYearPricePerMonthDiscounted,
    currencySymbol: tier?.product?.pricing?.currencySymbol,
  } as PlansTier
}

export const useTiersInfo = () => {
  const { tiers } = useStaticData<TierCollection>()

  const products = useMemo(
    () => ({
      individual: pruneTier(tiers, TierHierarchy.INDIVIDUAL),
      duo: pruneTier(tiers, TierHierarchy.DUO),
      family: pruneTier(tiers, TierHierarchy.FAMILY),
      familyPlus: pruneTier(tiers, TierHierarchy.FAMILY_PLUS),
    }),
    [tiers],
  )

  return products
}
